import RootMutations from './mutations'
import RootActions from './actions'
import RootGetters from './getters'
import RootState from './state'
export default {
    namespaced: true,
    state: RootState,
    mutations: RootMutations,
    actions: RootActions,
    getters: RootGetters
}
